package com.tovtalk.domain.entity

sealed class FeedItem {
    data class VideoItem(val post: Post) : FeedItem()
    data class NativeAdItem(val slotIndex: Int) : FeedItem()
    data class VideoAdItem(val slotIndex: Int) : FeedItem()
}

enum class FeedAdKind { NATIVE, VIDEO }

fun buildFeedItems(
    posts: List<Post>,
    showAds: Boolean,
    adsEveryNPosts: Int = 5,
    adKind: FeedAdKind = FeedAdKind.NATIVE,
): List<FeedItem> {
    if (!showAds || adsEveryNPosts <= 0) return posts.map { FeedItem.VideoItem(it) }
    val result = mutableListOf<FeedItem>()
    posts.forEachIndexed { index, post ->
        result.add(FeedItem.VideoItem(post))
        if ((index + 1) % adsEveryNPosts == 0) {
            val slot = index / adsEveryNPosts
            result.add(
                when (adKind) {
                    FeedAdKind.NATIVE -> FeedItem.NativeAdItem(slotIndex = slot)
                    FeedAdKind.VIDEO -> FeedItem.VideoAdItem(slotIndex = slot)
                }
            )
        }
    }
    return result
}
